// Mirror of /app/backend/content_states.py — keep IDs and colors in sync.
// 12 workflow states for content publications.

export const CONTENT_STATES = [
  { id: 'falta_material',   label: 'Falta material',       bg: '#F1EFE8', fg: '#5F5E5A' },
  { id: 'idea',             label: 'Idea',                 bg: '#FAEEDA', fg: '#854F0B' },
  { id: 'borrador',         label: 'Borrador',             bg: '#FBF0D9', fg: '#8A6D1B' },
  { id: 'redactado',        label: 'Redactado',            bg: '#FAF3D4', fg: '#7A6A12' },
  { id: 'grabado',          label: 'Grabado',              bg: '#E6E4FB', fg: '#463DA8' },
  { id: 'editar',           label: 'Editar',               bg: '#E6F1FB', fg: '#185FA5' },
  { id: 'disenar',          label: 'Diseñar',              bg: '#FCE7F3', fg: '#A21CAF' },
  { id: 'revision_interna', label: 'Revisión interna',     bg: '#FBF3E6', fg: '#9A6212' },
  { id: 'pendiente_aprobar',label: 'Pendiente de aprobar', bg: '#FCEBEB', fg: '#A32D2D' },
  { id: 'a_programar',      label: 'A programar',          bg: '#E1F5EE', fg: '#0F6E56' },
  { id: 'programado',       label: 'Programado',           bg: '#EAF3DE', fg: '#3B6D11' },
  { id: 'publicado',        label: 'Publicado',            bg: '#085041', fg: '#9FE1CB' },
  { id: 'cambios_solicitados', label: 'Cambios solicitados', bg: '#FBE9D7', fg: '#9A4D12' },
  { id: 'cancelada', label: 'Cancelada', bg: '#ECECEC', fg: '#6B6B6B' },
];

export const CONTENT_STATE_MAP = CONTENT_STATES.reduce((acc, s) => {
  acc[s.id] = s;
  return acc;
}, {});

export const getStateMeta = (id) =>
  CONTENT_STATE_MAP[id] || { id, label: id || '—', bg: '#E5E7EB', fg: '#374151' };

export const CONTENT_TYPES = [
  { id: 'reel', label: 'Reel' },
  { id: 'post', label: 'Post' },
  { id: 'carrusel', label: 'Carrusel' },
  { id: 'story', label: 'Story' },
  { id: 'video', label: 'Vídeo' },
];

export const CONTENT_CHANNELS = [
  { id: 'instagram', label: 'Instagram', color: '#E1306C' },
  { id: 'facebook', label: 'Facebook', color: '#1877F2' },
  { id: 'tiktok', label: 'TikTok', color: '#010101' },
  { id: 'linkedin', label: 'LinkedIn', color: '#0A66C2' },
  { id: 'youtube', label: 'YouTube', color: '#FF0000' },
  { id: 'twitter', label: 'Twitter / X', color: '#111111' },
];

// Pilares de contenido (lista fija, decisión usuaria 13/Oct/2026)
export const CONTENT_PILLARS = [
  { id: 'autoridad', label: 'Autoridad', color: '#2563EB' },
  { id: 'educacion', label: 'Educación', color: '#0D9488' },
  { id: 'viral', label: 'Viral', color: '#DB2777' },
  { id: 'emocional', label: 'Emocional', color: '#D97706' },
  { id: 'venta', label: 'Venta', color: '#16A34A' },
];
const _normPillar = (v) => String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
// Empareja un valor libre antiguo ("AUTORIDAD", "educación", "viral") con el pilar fijo; null si no coincide
export const matchPillar = (value) => {
  const n = _normPillar(value);
  if (!n) return null;
  return CONTENT_PILLARS.find((p) => p.id === n || _normPillar(p.label) === n || n.startsWith(p.id) || p.id.startsWith(n)) || null;
};
export const getPillarMeta = (value) => matchPillar(value) || (value ? { id: value, label: value, color: '#64748b', unknown: true } : null);

export const getChannelMeta = (id) => CONTENT_CHANNELS.find((c) => c.id === id) || { id, label: id, color: '#64748b' };

// Canales de una publicación: lista nueva `canales` o, si no, el `canal` legacy
export const getPostChannels = (post) => {
  if (Array.isArray(post?.canales) && post.canales.length) return post.canales.filter(Boolean);
  return post?.canal ? [post.canal] : [];
};

export const APPROVAL_PENDING_STATE = 'pendiente_aprobar';
export const APPROVAL_NEXT_STATE = 'a_programar';
export const FINAL_STATES = new Set(['publicado']);
